var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"title":_vm.$t('pages.portal.title')}}),_c('portal',{attrs:{"to":"layoutTwoside"}},[_c('img',{attrs:{"src":"/img/samples/auth-artwork.png"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }